
/**
 * Check if the user's location is in Poland based on timezone, language preferences,
 * or other available signals
 */
export function isUserFromPoland(): boolean {
  try {
    // Check timezone (Poland is in CET/CEST)
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timezone === 'Europe/Warsaw') {
      return true;
    }

    // Check browser language
    const browserLang = navigator.language || (navigator as any).userLanguage;
    if (browserLang && (browserLang.toLowerCase().startsWith('pl'))) {
      return true;
    }

    // Check if the browser language includes Polish in the languages array
    if (navigator.languages && navigator.languages.some(lang => lang.toLowerCase().startsWith('pl'))) {
      return true;
    }

    return false;
  } catch (e) {
    return false;
  }
}

/**
 * Get language from user's location, with fallback to saved preference
 */
export function getLanguageFromLocation(): string {
  try {
    // First check if user has a saved preference
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      return savedLanguage;
    }

    // If no saved preference, determine based on location
    // Only Polish users get Polish by default, everyone else gets English
    return isUserFromPoland() ? 'pl' : 'en';
  } catch (e) {
    return 'en'; // Default to English if there's an error
  }
}

/**
 * Helper function to get current language without hooks
 */
export function getLanguage(): string {
  try {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      return savedLanguage;
    }
    const detectedLanguage = getLanguageFromLocation();
    return detectedLanguage;
  } catch (e) {
    console.error('Error getting language:', e);
    return 'en'; // Default to English if there's an error
  }
}
